/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Used to create a person inside of an organisation
 */
export interface CreatePersonOrganisationCommand {
    /**
     * The email address the person will use
     */
    email: string;
    /**
     * The person\'s first name
     */
    firstName: string;
    /**
     * The person\'s last name
     */
    lastName: string;
    /**
     * The person\'s phone number
     */
    phoneNumber?: string;
    /**
     * A username that the person can use to log in (optional)
     */
    username?: string;
    /**
     * The organisation ID that will manage this person (optional)
     */
    organisationId?: number;
    /**
     * A list of roles the person has in this organisation
     */
    roles?: Array<CreatePersonOrganisationCommand.Roles>;
    /**
     * Should an introduction email be sent
     */
    sendNotification: boolean;
}
export namespace CreatePersonOrganisationCommand {
    export type Roles =
        | 'PLANNER'
        | 'CRP'
        | 'ADMIN'
        | 'BILLING_ADMIN'
        | 'PILOT'
        | 'PILOT_PLANNER'
        | 'PILOT_SUBMITTER'
        | 'PILOT_CREW_PLANNER'
        | 'PILOT_INSTANT_MISSION'
        | 'STUDENT'
        | 'STUDENT_EXTERNAL'
        | 'FLIGHT_LOG_COLLECTION_ORGANISATION'
        | 'FLIGHT_LOG_COLLECTION_OWN'
        | 'MAINTENANCE_CONTROLLER'
        | 'MAINTENANCE_PERSON'
        | 'MAINTENANCE_PERSON_EXTERNAL'
        | 'OBSERVER'
        | 'LOTAM_MANAGER'
        | 'READ_ONLY'
        | 'READ_ONLY_HIDDEN';
    export const Roles = {
        PLANNER: 'PLANNER' as Roles,
        CRP: 'CRP' as Roles,
        ADMIN: 'ADMIN' as Roles,
        BILLING_ADMIN: 'BILLING_ADMIN' as Roles,
        PILOT: 'PILOT' as Roles,
        PILOT_PLANNER: 'PILOT_PLANNER' as Roles,
        PILOT_SUBMITTER: 'PILOT_SUBMITTER' as Roles,
        PILOT_CREW_PLANNER: 'PILOT_CREW_PLANNER' as Roles,
        PILOT_INSTANT_MISSION: 'PILOT_INSTANT_MISSION' as Roles,
        STUDENT: 'STUDENT' as Roles,
        STUDENT_EXTERNAL: 'STUDENT_EXTERNAL' as Roles,
        FLIGHT_LOG_COLLECTION_ORGANISATION:
            'FLIGHT_LOG_COLLECTION_ORGANISATION' as Roles,
        FLIGHT_LOG_COLLECTION_OWN: 'FLIGHT_LOG_COLLECTION_OWN' as Roles,
        MAINTENANCE_CONTROLLER: 'MAINTENANCE_CONTROLLER' as Roles,
        MAINTENANCE_PERSON: 'MAINTENANCE_PERSON' as Roles,
        MAINTENANCE_PERSON_EXTERNAL: 'MAINTENANCE_PERSON_EXTERNAL' as Roles,
        OBSERVER: 'OBSERVER' as Roles,
        LOTAM_MANAGER: 'LOTAM_MANAGER' as Roles,
        READ_ONLY: 'READ_ONLY' as Roles,
        READ_ONLY_HIDDEN: 'READ_ONLY_HIDDEN' as Roles
    };
}
